import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LessonEntity,
  PaginatedLessonsResponse,
} from "../../services/lessons/lessons.types";

export type LessonState = {
  lessons: LessonEntity[];
  loading: boolean;
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
};

const initialPagination = {
  total: 0,
  page: 1,
  pageSize: 10,
  totalPages: 0,
};

const initialState: LessonState = {
  lessons: [],
  loading: false,
  pagination: initialPagination,
};

const lesson = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    clearLesson: (state) => {
      state.lessons = [];
      state.loading = false;
      state.pagination = initialPagination;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLessonsWithPagination: (
      state,
      action: PayloadAction<PaginatedLessonsResponse>
    ) => {
      state.lessons = action.payload.data;
      state.pagination = {
        total: action.payload.total,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        totalPages: action.payload.totalPages,
      };
      state.loading = false;
    },
    setLessons: (state, action: PayloadAction<LessonEntity[]>) => {
      state.lessons = action.payload;
      state.loading = false;
    },
    addLesson: (state, action: PayloadAction<LessonEntity>) => {
      state.lessons.unshift(action.payload);
      state.pagination.total += 1;
    },
    updateLesson: (
      state,
      action: PayloadAction<{ id: number; data: LessonEntity }>
    ) => {
      const index = state.lessons.findIndex(
        (lesson) => lesson.id === action.payload.id
      );
      if (index !== -1) {
        state.lessons[index] = action.payload.data;
      }
    },
    deleteLesson: (state, action: PayloadAction<number>) => {
      state.lessons = state.lessons.filter(
        (lessons) => lessons.id !== action.payload
      );
      state.pagination.total = Math.max(0, state.pagination.total - 1);
    },
  },
});

export default lesson;
export const {
  addLesson,
  clearLesson,
  deleteLesson,
  setLessons,
  setLessonsWithPagination,
  setLoading,
  updateLesson,
} = lesson.actions;
